import { AxiosResponse } from 'axios';
import { useGet } from 'hooks/useGet';
import type { Client } from 'types';

export const useClient = (id: string) => {
  return useGet<AxiosResponse<Client>>(`/clients/${id}/`, [id]);
};
